<template>
  <panel ref="panel" :title="`${$tc('seminar.applications')} (${filteredParticipants.length})`" :loader="loader" collapsable>
    <template v-slot:actions>
      <el-button
        v-if="!hideAdd && canEdit"
        type="primary"
        icon="el-icon-plus"
        size="medium"
        round
        @click="$refs.panel.expanded = true; openRegister = true"
      >
        {{ $tc('seminar.register_participant') }}
      </el-button>

        <template v-if="filteredParticipants.length">
        <el-tooltip :content="$tc('general.registration_fee')" placement="top">
          <el-button
            icon="el-icon-tickets"
            size="medium"
            circle
            @click="$emit('registration-fee')"
          />
        </el-tooltip>

        <el-tooltip :content="$tc('general.print')" placement="top">
          <el-button
            icon="el-icon-printer"
            size="medium"
            circle
            class="ml-10"
            @click="$emit('print-participants')"
          />
        </el-tooltip>

        <el-dropdown v-if="user.isAdmin" trigger="click" @command="setSortBy" class="ml-10">
          <el-tooltip :content="$tc('general.order_by')" placement="top">
            <el-button icon="el-icon-sort" size="medium" circle />
          </el-tooltip>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :disabled="sortBy === 'ALPHA'" command="ALPHA">{{ $tc('general.alphabetically') }}</el-dropdown-item>
            <el-dropdown-item :disabled="sortBy === 'DESC'" command="DESC">{{ $tc('general.latest_first') }}</el-dropdown-item>
            <el-dropdown-item :disabled="sortBy === 'ASC'" command="ASC">{{ $tc('general.oldest_first') }}</el-dropdown-item>
            <el-dropdown-item :disabled="sortBy === 'CLUB'" command="CLUB">{{ $tc('general.by_club') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </template>

        <seminar-participants-table
      :data="sortedParticipants"
      :can-edit="canEdit"
      :show-club-name="showClubName"
      @remove="onRemove"
      @edit="openEdit"
    />

    <manage-seminar-participants
      v-if="openRegister"
      :seminar="seminar"
      :club="selectedClub"
      :participants="participants"
      @close="closeRegister"
      @saved="onChange"
    />

    <manage-seminar-participant-positions
      v-if="editingParticipant"
      :participant="editingParticipant"
      :seminar="seminar"
      @close="editingParticipant = null"
      @saved="onChange"
    />
  </panel>
</template>

<script>
import { seminarParticipantsOrderBy } from '@/common/util'
import SeminarParticipantsTable from './SeminarParticipantsTable'
import ManageSeminarParticipants from './ManageSeminarParticipants'
import ManageSeminarParticipantPositions from './ManageSeminarParticipantPositions'

const SEMINAR_PARTICIPANTS_SORT_KEY = 'seminarParticipantsSortBy'

export default {
  components: {
    SeminarParticipantsTable,
    ManageSeminarParticipants,
    ManageSeminarParticipantPositions
  },

  props: {
    seminar: { type: Object, required: true },
    participants: { type: Array, default: () => [] },
    selectedClub: { type: Object, default: null },
    canEdit: { type: Boolean, default: false },
    showClubName: { type: Boolean, default: false },
    hideAdd: { type: Boolean, default: false },
    loader: { type: Boolean, default: false }
  },

  data () {
    return {
      openRegister: false,
      editingParticipant: null,
      sortBy: 'DESC'
    }
  },

  computed: {
    user () {
      return this.$store.state.auth.user
    },
    filteredParticipants () {
      if (this.user?.isAdmin) return this.participants
      const clubId = this.user?.club?.id
      if (!clubId) return []
      return this.participants.filter(p => parseInt(p.club?.id) === parseInt(clubId))
    },
    sortedParticipants () {
      return seminarParticipantsOrderBy(this.filteredParticipants, this.sortBy)
    }
  },

  created () {
    this.sortBy = localStorage.getItem(SEMINAR_PARTICIPANTS_SORT_KEY) || 'DESC'
  },

  methods: {
    setSortBy (sortBy) {
      localStorage.setItem(SEMINAR_PARTICIPANTS_SORT_KEY, sortBy)
      this.sortBy = sortBy
    },
    onChange () {
      this.$emit('participants-change')
      this.closeRegister()
      this.editingParticipant = null
    },
    async onRemove (row) {
      try {
        await this.$store.dispatch('seminars/removeParticipant', {
          seminarId: this.seminar.id,
          participantId: row.id
        })
        this.$emit('participants-change')
      } catch (e) {
        this.$message.error(e?.message || this.$tc('messages.error'))
      }
    },
    openEdit (participant) {
      this.editingParticipant = participant
    },
    closeRegister () {
      this.openRegister = false
    }
  }
}
</script>
